import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dramatic%20artistic%20illustration%20of%20Korean%20manhwa%20comic%20panels%20floating%20in%20a%20dreamy%20abstract%20space%2C%20warm%20coral%20and%20gold%20gradients%2C%20ethereal%20atmosphere%2C%20soft%20bokeh%20effects%2C%20dynamic%20composition%2C%20modern%20web%20design%20background&width=1920&height=900&seq=hero-bg-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white mb-4 leading-tight">
            韩国漫画无删减漫画下拉式
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            妖精动漫精选无删减韩国漫画，下拉式阅读模式搭配免费韩漫大全，资源丰富、界面友好，操作简单便捷，让您轻松找到心仪的韩漫作品。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/all"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-book-open-line"></i>
              开始阅读
            </Link>
            <Link
              to="/category/all"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/20 backdrop-blur-sm text-white border border-white/30 rounded-full font-medium text-sm hover:bg-white/30 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-compass-3-line"></i>
              探索分类
            </Link>
          </div>

          <div className="mt-10 flex items-center justify-center gap-8">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">2000+</div>
              <div className="text-xs text-white/60 mt-1">漫画作品</div>
            </div>
            <div className="w-px h-10 bg-white/20" />
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">500万+</div>
              <div className="text-xs text-white/60 mt-1">月活跃读者</div>
            </div>
            <div className="w-px h-10 bg-white/20" />
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">99.9%</div>
              <div className="text-xs text-white/60 mt-1">正版完整</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}